import { Row } from 'antd';
import styled from 'styled-components';
import { APP_SHELL_THEME } from '@/styles/appShellTheme';

export const ActionBar = styled(Row)`
  margin-bottom: 18px;
`;

export const DealsWithoutMediaPlansStat = styled.span`
  display: inline-flex;
  align-items: center;
  margin-left: 24px;
`;

export const FilterHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 18px 20px;
  margin-bottom: 18px;
  background: ${APP_SHELL_THEME.insetPanelBg};
  border: 1px solid ${APP_SHELL_THEME.insetPanelBorder};
  border-radius: 10px;
`;

export const FilterHeaderTopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

export const FilterHeaderSearch = styled.div`
  flex: 1 1 320px;
  max-width: 420px;
  min-width: 240px;
`;

export const FilterHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;

  .media-plan-reset-filters-btn.ant-btn-default:disabled,
  .media-plan-reset-filters-btn.ant-btn-default.ant-btn-disabled {
    color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.35) !important;
    background: rgba(${APP_SHELL_THEME.overlayRgb}, 0.04) !important;
    border-color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.1) !important;
    opacity: 1 !important;
    cursor: not-allowed;
    box-shadow: none !important;
  }

  .media-plan-reset-filters-btn.ant-btn-default:not(:disabled) {
    color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.88);
    background: rgba(${APP_SHELL_THEME.overlayRgb}, 0.08);
    border-color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.22);
  }

  .media-plan-reset-filters-btn.ant-btn-default:not(:disabled):hover {
    color: ${APP_SHELL_THEME.text};
    background: rgba(${APP_SHELL_THEME.overlayRgb}, 0.14);
    border-color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.35);
  }
`;

export const FilterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
  align-items: start;
`;

export const FilterField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

export const FilterLabel = styled.label`
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.55);
`;

export const FilterFieldWide = styled(FilterField)`
  grid-column: span 2;

  @media (max-width: 900px) {
    grid-column: span 1;
  }
`;

export const StyledContainer = styled.div`
  white-space: pre-wrap;

  .campaign,
  .deal-id,
  .client,
  .status,
  .manager,
  .start-date,
  .end-date,
  .channel,
  .margin,
  .total-budget,
  .actions {
    text-overflow: ellipsis;
  }

  .actions {
    min-width: 170px !important;
    width: 170px !important;
    white-space: nowrap;
  }

  .ant-table-thead > tr > th.actions {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .ant-table-thead > tr > th.actions.ant-table-cell-fix-right {
    background: ${APP_SHELL_THEME.tableFixedHeaderBg} !important;
  }

  .ant-table-tbody > tr > td.actions.ant-table-cell-fix-right {
    background: ${APP_SHELL_THEME.tableFixedBodyBg} !important;
  }

  .ant-table-tbody > tr:hover > td.actions.ant-table-cell-fix-right {
    background: ${APP_SHELL_THEME.tableFixedBodyHoverBg} !important;
  }
`;
